// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[data-v-0d419b2d]::-webkit-calendar-picker-indicator {\n    display: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
